<div class="modal-header" mat-dialog-title>
  <div class="modal-header-icon">
    <mat-icon class="material-symbols-outlined">payments</mat-icon>
  </div>
  <div class="modal-header-titles">
    <h2 class="modal-title">Lançar financeiro</h2>
    <span class="modal-subtitle">A conta é gerada a partir do serviço tomado, com as parcelas já definidas na nota</span>
  </div>
  <div class="modal-header-close-btn-container">
    <button mat-icon-button type="button" class="modal-close-btn" (click)="cancelar()">
      <mat-icon class="material-symbols-outlined">close</mat-icon>
    </button>
  </div>
</div>

<mat-dialog-content class="modal-content">
  @if (isLoading) {
  <div class="d-flex justify-content-center py-5">
    <mat-spinner [diameter]="32"></mat-spinner>
  </div>
  } @else {

  @if (erroBloqueante) {
  <app-alert-card type="error" class="mb-3">{{ erroBloqueante }}</app-alert-card>
  }

  @if (detalhe) {
  <!-- Dados vindos da nota: somente leitura, para a conta não divergir do documento fiscal -->
  <div class="secao">
    <div class="secao-titulo">Dados do serviço tomado</div>
    <div class="row">
      <div class="col-12 col-md-6 mb-2">
        <small class="d-block rotulo">Fornecedor</small>
        <span class="valor">{{ detalhe.nomeEmitente || '—' }}</span>
      </div>
      <div class="col-6 col-md-3 mb-2">
        <small class="d-block rotulo">Documento</small>
        <span class="valor">{{ detalhe.numeroNFSe || '—' }}</span>
      </div>
      <div class="col-6 col-md-3 mb-2">
        <small class="d-block rotulo">Emissão</small>
        <span class="valor">{{ detalhe.datetimeEmissaoDps | date:'dd/MM/yyyy' }}</span>
      </div>
      <div class="col-12 mb-2">
        <small class="d-block rotulo">Descrição</small>
        <span class="valor">{{ detalhe.descricaoServico || '—' }}</span>
      </div>
      <div class="col-12 col-md-6 mb-2">
        <small class="d-block rotulo">Valor líquido (a pagar)</small>
        <span class="valor valor-destaque">{{ valorLiquido | abnt:'preco':2 }}</span>
      </div>
    </div>
  </div>

  <!-- Parcelas: exibidas para conferência; são exatamente as já definidas na nota -->
  <div class="secao">
    <div class="secao-titulo">Parcelas ({{ detalhe.parcelas.length }})</div>
    <table mat-table [dataSource]="detalhe.parcelas" class="tabela-parcelas">
      <ng-container matColumnDef="numero">
        <th mat-header-cell *matHeaderCellDef>Nº</th>
        <td mat-cell *matCellDef="let p">{{ p.numeroParcela }}</td>
      </ng-container>
      <ng-container matColumnDef="vencimento">
        <th mat-header-cell *matHeaderCellDef>Vencimento</th>
        <td mat-cell *matCellDef="let p">{{ p.dataVencimento | date:'dd/MM/yyyy' }}</td>
      </ng-container>
      <ng-container matColumnDef="valor">
        <th mat-header-cell *matHeaderCellDef class="text-end">Valor</th>
        <td mat-cell *matCellDef="let p" class="text-end">{{ p.valorParcela | abnt:'preco':2 }}</td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>

  <!-- O que o usuário precisa completar para o lançamento -->
  <div class="secao" [formGroup]="form">
    <div class="secao-titulo">Dados financeiros</div>
    <div class="row">
      <div class="col-12 col-md-6">
        <app-select-pesquisavel label="Categoria financeira" [control]="$any(form.get('idCategoriaFinanceira'))"
          [offlineList]="listaCategorias" idField="idCategoriaFinanceira" nameField="descricao" [isOptional]="false"
          placeholder="Selecione...">
        </app-select-pesquisavel>
      </div>
      <div class="col-12 col-md-6">
        <app-select-pesquisavel label="Centro de custo" [control]="$any(form.get('idCentroCusto'))"
          [offlineList]="listaCentrosCusto" idField="idCentroCusto" nameField="nome"
          [isOptional]="!isCentroCustoObrigatorio" placeholder="Selecione...">
        </app-select-pesquisavel>
      </div>
      <div class="col-12 col-md-6">
        <app-select-pesquisavel label="Forma de pagamento" [control]="$any(form.get('idFormaPagamento'))"
          [offlineList]="listaFormasPagamento" idField="idFormaPagamento" nameField="descricao"
          [isOptional]="!isFormaPagamentoObrigatoria" placeholder="Selecione...">
        </app-select-pesquisavel>
      </div>
      <div class="col-12 col-md-6">
        <app-select-pesquisavel label="Conta financeira" [control]="$any(form.get('idContaFinanceira'))"
          [offlineList]="listaContasFinanceiras" idField="idContaFinanceira" nameField="descricao"
          [isOptional]="!isContaFinanceiraObrigatoria" placeholder="Selecione...">
        </app-select-pesquisavel>
      </div>
    </div>
  </div>
  }
  }
</mat-dialog-content>

<mat-dialog-actions class="modal-footer">
  <button mat-stroked-button class="btn-secondary" (click)="cancelar()" [disabled]="isSaving">Cancelar</button>
  <button mat-flat-button class="btn-primary" (click)="confirmar()"
    [disabled]="isSaving || isLoading || !!erroBloqueante">
    @if (isSaving) {
    <mat-spinner [diameter]="18"></mat-spinner>
    } @else {
    <span>Lançar financeiro</span>
    }
  </button>
</mat-dialog-actions>
